import { Directive, Input, Output, HostListener, EventEmitter } from '@angular/core';
import { ConfirmDialogData, ConfirmService } from './confirm.service';

@Directive({
	selector: '[confirmMessage]'
})
export class ConfirmDirective {
	/** The question to ask. */
	@Input('confirmMessage') message!: string | ConfirmDialogData;
	/** Emits *only* if user clicked “OK”. */
	@Output('confirm') confirmed = new EventEmitter<void>();

	constructor(private confirm: ConfirmService) { }

	@HostListener('click', ['$event'])
	async onClick(event: Event) {
		// prevent the original click
		event.preventDefault();
		event.stopImmediatePropagation();

		if (await this.confirm.confirm(this.message)) {
			this.confirmed.emit();
		}
	}
}
